export enum WashEngineTurnScheduleStatus {
  Schedule = ('Agendados'),
  Removed = ('Removidos da fila'),
  Never = ('Nunca Agendados')
}
